export default __webpack_public_path__ + "assets/0c50ed0546d473a39db9e49951bcf4c4.png";